import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { ArrowLeft, Printer } from 'lucide-react'
import { Alerta, Badge, Boton, Cargando } from '../../components/kit'
import { PlanchetaDoc } from '../../components/inventario/PlanchetaDoc'
import { useImprimirPlancheta, usePlancheta } from '../../queries/useInventario'
import { Plancheta as DatosPlancheta } from '../../types/inventario'
import { mensajeDeError } from '../../utils/errores'
import { formatoFecha } from '../../utils/fecha'
import { PLANCHETA } from '../../utils/inventario'

/**
 * La plancheta de una oficina lista para imprimir desde el navegador (o guardar como
 * PDF). «Imprimir» registra la impresión —la oficina queda actualizada— y abre el
 * diálogo de impresión con lo que el servidor devolvió en ese momento.
 */
export default function Plancheta() {
  const { codigo = '' } = useParams()
  const vista = usePlancheta(codigo)
  const imprimir = useImprimirPlancheta()
  const [impresa, setImpresa] = useState<DatosPlancheta | null>(null)

  if (vista.isLoading) return <Cargando />
  if (vista.isError || !vista.data) return <Alerta tipo="error">{mensajeDeError(vista.error, 'No se encontró la oficina.')}</Alerta>
  const { recinto, bienes } = impresa ?? vista.data

  const alImprimir = () =>
    imprimir.mutate(codigo, {
      onSuccess: (datos) => {
        setImpresa(datos)
        // Después de que React pinte lo que devolvió el servidor.
        setTimeout(() => window.print(), 50)
      },
    })

  return (
    <div className="pila pila--amplia">
      <div className="pila no-print">
        <Boton variante="text" tam="sm" icono={ArrowLeft} to={`/app/oficinas/${codigo}`}>{recinto.nombre}</Boton>
        <header className="pagina__cabecera pagina__cabecera--con-accion">
          <div>
            <h1 className="dcc-t-heading-m">Plancheta de {recinto.nombre}</h1>
            <p className="texto-secundario">
              <Badge tono={PLANCHETA[recinto.plancheta_estado].tono} punto>{PLANCHETA[recinto.plancheta_estado].texto}</Badge>{' '}
              {recinto.plancheta_impresa ? `Última impresión: ${formatoFecha(recinto.plancheta_impresa)}` : 'Nunca impresa'}
            </p>
          </div>
          <Boton icono={Printer} onClick={alImprimir} cargando={imprimir.isPending}>Imprimir</Boton>
        </header>
        <Alerta tipo="info">
          Al imprimir, la oficina queda con la plancheta actualizada. Imprime en tamaño carta, al 100 % y sin encabezados del
          navegador; también puedes guardarla como PDF.
        </Alerta>
        {imprimir.isError && <Alerta tipo="error">{mensajeDeError(imprimir.error)}</Alerta>}
      </div>
      <div className="plancheta-hoja">
        <PlanchetaDoc recinto={recinto} bienes={bienes} fecha={new Date()} />
      </div>
    </div>
  )
}
